import { FileText } from "lucide-react";

export default function TermsPage() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-12 md:px-10 md:py-16">
      <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Legal</p>
      <h1 className="mt-2 font-display text-4xl font-medium tracking-tight">Terms &amp; Conditions</h1>
      <p className="mt-2 text-sm text-muted-foreground">Last updated: 4 June 2026</p>
      <div className="prose prose-invert mt-8 max-w-none text-sm leading-relaxed text-foreground/90">
        <p><FileText className="mr-1 inline h-4 w-4 text-primary" /> By creating a Zuntria account you accept these terms.</p>

        <h2 className="mt-6 font-display text-xl">1. Eligibility</h2>
        <p>You must be 18+ and legally able to enter into a contract in your country.</p>

        <h2 className="mt-6 font-display text-xl">2. Your account</h2>
        <p>You are responsible for keeping your login, wallet PIN and bank details secure. Notify us immediately at support@zuntria.ai if your account is compromised.</p>

        <h2 className="mt-6 font-display text-xl">3. Wallet &amp; payments</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Top-ups credit your wallet instantly via Stripe.</li>
          <li>Withdrawals are processed manually within 24 hours during business days.</li>
          <li>Withdrawals require a verified bank account and a wallet PIN.</li>
          <li>We may pause withdrawals temporarily for fraud checks.</li>
        </ul>

        <h2 className="mt-6 font-display text-xl">4. Ajo &amp; group savings</h2>
        <p>Zuntria provides tools to plan and run Ajo groups. We are not party to your group's agreements. Members are responsible for their contributions. Missing a cycle triggers automatic trust-score deductions and may draw from an optional insurance pool if enabled.</p>

        <h2 className="mt-6 font-display text-xl">5. AI assistants</h2>
        <p>AI replies are generated by language models and may contain errors. Don't rely on AI output for legal, medical or financial decisions.</p>

        <h2 className="mt-6 font-display text-xl">6. Acceptable use</h2>
        <p>No fraud, money-laundering, illegal goods/services, harassment, or scraping our APIs. Violations result in account termination and possible report to authorities.</p>

        <h2 className="mt-6 font-display text-xl">7. Subscriptions</h2>
        <p>Pro (£14.99/mo) gives the complete Zuntria execution system including unlimited AI, 2× rewards, and unlimited marketplace listings. Subscriptions are non-refundable once activated for the period purchased.</p>

        <h2 className="mt-6 font-display text-xl">8. Liability</h2>
        <p>Zuntria is provided "as is". We're not liable for indirect or consequential losses. Our total liability for any claim is capped at the fees you paid in the 12 months before the claim.</p>

        <h2 className="mt-6 font-display text-xl">9. Changes</h2>
        <p>We may update these terms; material changes will be announced via in-app notification 14 days before they take effect.</p>

        <h2 className="mt-6 font-display text-xl">10. Contact</h2>
        <p><a className="text-primary underline" href="mailto:support@zuntria.ai">support@zuntria.ai</a></p>
      </div>
    </div>
  );
}
